export default {
  install (Vue) {
    const deepSet = (obj, key, value) => {
      if (typeof obj[key] === 'object') {
        Object.keys(obj[key]).forEach(key2 => {
          deepSet(obj[key], key2, value && value[key2])
        })
      }
      Vue.set(obj, key, value)
      return obj
    }
    Vue.deepSet = Vue.prototype.$deepSet = deepSet
  }
}
